export default "__VITE_ASSET__VAAPuYhh__"